import { useState, useCallback } from "react";
import ConfirmationDialog, {
  ConfirmationDialogProps,
} from "../components/ConfirmationDialog";

interface ConfirmDialogOptions {
  title: string;
  content: string;
  isDangerous?: boolean;
}

const useConfirmDialog = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOptions, setDialogOptions] =
    useState<ConfirmDialogOptions | null>(null);
  const [resolvePromise, setResolvePromise] = useState<
    ((value: boolean) => void) | null
  >(null);

  const openConfirmDialog = useCallback((options: ConfirmDialogOptions) => {
    setDialogOptions(options);
    setDialogOpen(true);
    return new Promise<boolean>((resolve) => {
      setResolvePromise(() => resolve);
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setDialogOpen(false);
    if (resolvePromise) {
      resolvePromise(true);
    }
  }, [resolvePromise]);

  const handleCancel = useCallback(() => {
    setDialogOpen(false);
    if (resolvePromise) {
      resolvePromise(false);
    }
  }, [resolvePromise]);

  return {
    confirmDialog: openConfirmDialog,
    ConfirmDialogComponent: dialogOptions ? (
      <ConfirmationDialog
        open={dialogOpen}
        title={dialogOptions.title}
        content={dialogOptions.content}
        isDangerous={dialogOptions.isDangerous}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    ) : null,
  };
};

export default useConfirmDialog;
